import { __module as l } from "./ghl-ui.es1714.js";
import { i as c } from "./ghl-ui.es1541.js";
import { a as m } from "./ghl-ui.es1689.js";
(function(i, u) {
  var f = c.default;
  Object.defineProperty(u, "__esModule", {
    value: !0
  }), u.default = void 0;
  var r = f(m), s = {
    // Year
    y: function(t, e) {
      var a = t.getUTCFullYear(), o = a > 0 ? a : 1 - a;
      return (0, r.default)(e === "yy" ? o % 100 : o, e.length);
    },
    // Month
    M: function(t, e) {
      var a = t.getUTCMonth();
      return e === "M" ? String(a + 1) : (0, r.default)(a + 1, 2);
    },
    // Day of the month
    d: function(t, e) {
      return (0, r.default)(t.getUTCDate(), e.length);
    },
    // AM or PM
    a: function(t, e) {
      var a = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (e) {
        case "a":
        case "aa":
          return a.toUpperCase();
        case "aaa":
          return a;
        case "aaaaa":
          return a[0];
        case "aaaa":
        default:
          return a === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(t, e) {
      return (0, r.default)(t.getUTCHours() % 12 || 12, e.length);
    },
    // Hour [0-23]
    H: function(t, e) {
      return (0, r.default)(t.getUTCHours(), e.length);
    },
    // Minute
    m: function(t, e) {
      return (0, r.default)(t.getUTCMinutes(), e.length);
    },
    // Second
    s: function(t, e) {
      return (0, r.default)(t.getUTCSeconds(), e.length);
    },
    // Fraction of second
    S: function(t, e) {
      var a = e.length, o = t.getUTCMilliseconds(), g = Math.floor(o * Math.pow(10, a - 3));
      return (0, r.default)(g, e.length);
    }
  }, d = s;
  u.default = d, i.exports = u.default;
})(l, l.exports);
var C = l.exports;
export {
  C as l
};
